// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pe-settings-tab__export {
    margin-bottom: 20px;
}

.pe-settings-tab__export ul {
    margin-top: 10px;
    border: 1px solid #e0e0e0e5;
    padding: 10px;
    background-color: #fff;
}

.pe-settings-tab__export span {
    display: inline-block;
}

.pe-settings-tab__backup-status {
    margin-left: 5px;
}

.pe-settings-tab__backup-actions button {
    margin-left: 5px !important;
}

.pe-settings-tab__backup-container {
    margin-left: 30px;
}

.pe-settings-tab__export-cancel-button {
    margin-left: 10px !important;
}

.components-snackbar-list {
    position: fixed !important;
    bottom: 20px;
    left: 182px;
    transform: none;
    z-index: 100000;
}

.components-snackbar {
    margin-bottom: 10px;
}

.wp-admin.folded .components-snackbar-list {
    left: 58px;
}

.pe-settings-tab__import-file-upload {
    margin-bottom: 20px;
}

.pe-settings-tab__import-file-upload-info {
    margin-top: 10px;
    font-size: 14px;
}

.pe-dropzone {
    border: 3px dashed #ccc;
    padding: 20px;
    text-align: center;
}

.pe-dropzone--active {
    border-color: #0073aa;
}

.pe-dropzone p {
    margin: 0;
}

.components-form-file-upload {
    margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/backup-panel/css/general.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".pe-settings-tab__export {\n    margin-bottom: 20px;\n}\n\n.pe-settings-tab__export ul {\n    margin-top: 10px;\n    border: 1px solid #e0e0e0e5;\n    padding: 10px;\n    background-color: #fff;\n}\n\n.pe-settings-tab__export span {\n    display: inline-block;\n}\n\n.pe-settings-tab__backup-status {\n    margin-left: 5px;\n}\n\n.pe-settings-tab__backup-actions button {\n    margin-left: 5px !important;\n}\n\n.pe-settings-tab__backup-container {\n    margin-left: 30px;\n}\n\n.pe-settings-tab__export-cancel-button {\n    margin-left: 10px !important;\n}\n\n.components-snackbar-list {\n    position: fixed !important;\n    bottom: 20px;\n    left: 182px;\n    transform: none;\n    z-index: 100000;\n}\n\n.components-snackbar {\n    margin-bottom: 10px;\n}\n\n.wp-admin.folded .components-snackbar-list {\n    left: 58px;\n}\n\n.pe-settings-tab__import-file-upload {\n    margin-bottom: 20px;\n}\n\n.pe-settings-tab__import-file-upload-info {\n    margin-top: 10px;\n    font-size: 14px;\n}\n\n.pe-dropzone {\n    border: 3px dashed #ccc;\n    padding: 20px;\n    text-align: center;\n}\n\n.pe-dropzone--active {\n    border-color: #0073aa;\n}\n\n.pe-dropzone p {\n    margin: 0;\n}\n\n.components-form-file-upload {\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
